import React, { useState, useEffect, useRef } from "react";
import "./ListUser.scss";
import "../DashBoard/sliding.css";
import { Modal, Button } from "react-bootstrap";

import { useNavigate } from "react-router-dom";


import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import { userReducer } from "../../Redux/store";
import name from "../../images/new_ui/name_image.svg";
import userid from "../../images/new_ui/userid_image.svg";
import roletype from "../../images/new_ui/roletype_image.svg";
import mobileno from "../../images/new_ui/mobile_image.svg";
import emailid from "../../images/new_ui/email_id.svg";
import actdate from "../../images/new_ui/activation_image.svg";
import deactdate from "../../images/new_ui/deactivation_image.svg";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as UsersSVG } from "../../images/new_ui/add_user.svg";



import { ReactComponent as DeleteSVG } from "../../images/new_ui/delete-purple.svg";
import { ReactComponent as EditSVG } from "../../images/new_ui/edit-purple.svg";
import SearchBarComponent from "../../components/searchBar/searchBarComponent";

import {
  SuccessAlert,
  FailureAlert,
  InformationAlert,
  SuccessUpdate,
  FailureUpdate,
  SuccessDelete,
} from "../../components/Alert_msg/alert_msg";
// import ListPermissions from "../ListPermissions/ListPermissions";

function ListUsers() {
  // Dispatch function
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //API related selectors
  const token = useSelector((state) => state.AccessTocken.accessTocken);

  //Permission for Roles
  // const Add_Permission = useSelector(
  //   (state) => state.AccessTocken.Add_Permission
  // );
  // const Edit_Permission = useSelector(
  //   (state) => state.AccessTocken.Edit_Permission
  // );
  // const Delete_Permission = useSelector(
  //   (state) => state.AccessTocken.Delete_Permission
  // );
  // const View_Permission = useSelector(
  //   (state) => state.AccessTocken.View_Permission
  // );

  const user_edit = useSelector((state) => state.user.user_edit);
  const [userData, setUserData] = useState([]);

  const [userValidated, setUserValidated] = useState(false);
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteOpen, setDeleteOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState(null);

  // const openPopup = () => {
  //   setIsOpen(true);
  // };

  // const closePopup = () => {
  //   setIsOpen(false);
  //   getSelectedUser(null);
  // };

  // const closeUpdateUserPopup = () => {
  //   setIsOpen(false);
  //   getSelectedUser(null);
  //   setUserData([]);
  //   getUsersList();
  // };

  // const [isPermissionOpen, setIsPermissionOpen] = useState(false);
  const [selectedUser, getSelectedUser] = useState(null);
  
  // const openPermissionPopup = () => {
  //   setIsPermissionOpen(true);
  // };

  

  // const closePermissionPopup = () => {
  //   setIsPermissionOpen(false);
  // };

  const openDeleteModal = (userId, userName) => {
    setSelectedUserId(userId);

    console.log("selectedUserId", selectedUserId);
    setSelectedUserName(userName);
    setDeleteOpen(true);
  };

  // Close delete modal
  const closeDeleteModal = () => {
    setDeleteOpen(false);
  };

  //Header for API's
  // const options = {
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //   },
  // };

  const listLimit = useSelector((state) => state.AccessTocken.recordsPerPage);

  // division response for Division Dropdown

  async function getUsersList() {
    dispatch(sidebarReducer.apiLoad(true));
    // setApiLaod(true);
    await axios

      .get(
        "cmsuser/listAllUsersByCompany/" +
        JSON.parse(sessionStorage.getItem("userdata")).te_companyid,
        {
          headers: {
            Authorization:
              "Bearer" + " " + sessionStorage.getItem("access_token"),
          },
        }
      )


      .then((response) => {
    
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          setUserData(response.data.data);
    

        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const handleSearchSubmit = (event) => {
    event.preventDefault();
    getSearchList(searchTerm);
  };
 
  
  async function getSearchList(searchTerm) {
    dispatch(sidebarReducer.apiLoad(true));
    try {
      const url = `cmsuser/listAllUsersByCompany/${JSON.parse(sessionStorage.getItem("userdata")).te_companyid}`;
      const params = searchTerm ? { s: searchTerm } : {};
  
      const response = await axios.get(url, {
        params: params,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      });
  
      
      if (response.status === 200) {
        dispatch(sidebarReducer.apiLoad(false));
      
        setUserData(response.data.data);
        // console.log("abccc",response.data.data);
       
      }
    } catch (err) {
      dispatch(sidebarReducer.apiLoad(false));
      dispatch(sidebarReducer.stringUpdate("AppDown"));
      console.error("Search error:", err);
      toast.error("An error occurred while searching. Please try again.");
    }
  }
  var addnameColor = "black";

  if (userValidated) {
    addnameColor = "green";
  } else {
    addnameColor = "red";
  }
  // useEffect(() => {
  //   if (View_Permission === 1) {
  //     // responseData();
  //     getUsersList
  //   }
  //   return () => {
  //     console.log("resp in return");
  //   };
  //   // eslint-disable-next-line
  // }, [View_Permission]);
  useEffect(() => {
    getUsersList();
  }, []);

  useEffect(() => {
    getSearchList();
  }, []);

  //Table and slidingpane width
  const ref = useRef(null);

  const onEdit = (user) => {
    getSelectedUser(user);
    setIsEditing(true);
    navigate("/edit?user=" + user.te_userid, { state: { isEditing: true } });
    console.log("selected User", user);
  };

  
  const DeleteUser = async (userId) => {
    try {
      const response = await axios.post(`/cmsuser/delete/${userId}`, null, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      });
      dispatch(sidebarReducer.apiLoad(false));
      if (response.data.status === 200) {
        if (response.data.message === "CMS USER DELETED SUCCESSFULLY") {
          toast.success("USER DELETED SUCCESSFULLY", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }

        setDeleteOpen(false);
        getUsersList();
      } else {
        toast.warn(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      closeDeleteModal();
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return 'N/A';
    return phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`;
  };
  const highlightText = (text, highlight) => {
    if (!highlight.trim()) {
      return text;
    }
    const escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedHighlight})`, 'gi');
    return text.replace(regex, '<span class="highlighted-text">$1</span>');
  };
 

  return (
    <div className="list-users">
      <ToastContainer closeButton={false} />

      {/* {View_Permission === 1 ? ( */}
      <div className="container-fluid">
        <div className="container">
          <div className="row">
          
            <SearchBarComponent
              className="search-bar-div"
              value={searchTerm}
              onChange={handleSearchChange}
              onSubmit={handleSearchSubmit}
            />
          </div>
        </div>

        <div className="container">


          <div className="user-table-container">
            <div className="title-area">
              <h5>User List</h5>
              <button
                className="add-screen-button"
                type="button"
                onClick={() =>
                  navigate("/add", { state: { isEditing: false } })
                }
                style={{ cursor: sessionStorage.getItem("permissions") && 
                JSON.parse(sessionStorage.getItem("permissions"))[0].te_has_add === 1 ? "pointer" : "not-allowed" }}
                disabled={sessionStorage.getItem("permissions") && 
                JSON.parse(sessionStorage.getItem("permissions"))[0].te_has_add !== 1}
                
              >
                <UsersSVG
                  style={{ width: "40px", height: "auto", 
                 
              }}
                  
                />

                <p>Create New User</p>
              </button>
            </div>

            <hr></hr>
            <div className=" ">
              <div className="container-fluid g-0">
                <div className="table-wrapper-scroll-y user-list-table">
                  {apiLoad ? (
                    <div
                      style={{
                        height: "80vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div className="spinnerApi"></div>
                    </div>
                  ) : (
                    <>
                  
                      <table key={JSON.stringify(userData)} stickyHeader aria-label="sticky table">
                        <thead>
                          <tr>
                            <th>
                              <img className="filter-icon" src={name} />
                              Name{" "}
                            </th>
                            <th>
                              <img className="filter-icon" src={userid} />
                              User Name
                            </th>
                            <th>
                              <img className="filter-icon" src={roletype} />
                              Role type
                            </th>
                            <th>
                              <img className="filter-icon" src={mobileno} />
                              Mobile Number
                            </th>
                            <th>
                              <img className="filter-icon" src={emailid} />
                              Email
                            </th>
                            <th>
                              <img className="filter-icon" src={actdate} />
                              Activation Date
                            </th>
                            <th>
                              <img className="filter-icon" src={deactdate} />
                              Deactivation Date
                            </th>

                          </tr>
                        </thead>
                        {sessionStorage.getItem("permissions") && 
                        JSON.parse(sessionStorage.getItem("permissions"))[0].te_has_view === 1 ? (


                        <tbody>
                          {userData.map((item) => (
                          
                            <tr key={item.te_userid}>
                              <td className="responsive-screen" dangerouslySetInnerHTML={{
                                __html: highlightText(`${item.te_firstname} `, searchTerm)
                              }} />
                              <td className="responsive-screen" dangerouslySetInnerHTML={{
                                __html: highlightText(item.te_username || 'N/A', searchTerm)
                              }} />
                              <td className="responsive-screen" dangerouslySetInnerHTML={{
                                __html: highlightText(item.roles.te_role_name || 'N/A', searchTerm)
                              }} />
                            
                              <td className="responsive-screen" dangerouslySetInnerHTML={{
  __html: highlightText(formatPhoneNumber(item.te_phone) || 'N/A', searchTerm)
}} />
                              <td className="responsive-screen">
                                {item.te_useremail ? (
                                  <span
                                    title={item.te_useremail}
                                    className="email-truncated"
                                    dangerouslySetInnerHTML={{
                                      __html: highlightText(item.te_useremail, searchTerm)
                                    }}
                                  />
                                ) : (
                                  "N/A"
                                )}
                              </td>
                              <td className="responsive-screen">
                                {item.te_useractivatedat
                                  ? highlightText(new Date(item.te_useractivatedat).toLocaleDateString("en-GB"), searchTerm)
                                  : "N/A"}
                              </td>
                              <td className="date-cell">
                                {item.te_userdeactivatedat
                                  ? highlightText(new Date(item.te_userdeactivatedat).toLocaleDateString("en-GB"), searchTerm)
                                  : "N/A"}
                                <div className="delete-edit-icons">
                                  {sessionStorage.getItem("permissions") &&
                                    JSON.parse(sessionStorage.getItem("permissions"))[0].te_has_edit === 1 && (
                                      <EditSVG
                                        onClick={() => onEdit(item)}
                                        style={{
                                          cursor: "pointer",
                                          color: "#703BF7",
                                        }}
                                      />
                                    )}
                                  {/* <EditSVG
                                    onClick={() => onEdit(item)}
                                    style={{
                                      cursor: "pointer",
                                      color: "#703BF7",
                                    }}
                                  /> */}
                                  {sessionStorage.getItem("permissions") &&
                                    JSON.parse(sessionStorage.getItem("permissions"))[0].te_has_delete === 1 && (
                                      <DeleteSVG
                                        onClick={() => openDeleteModal(item.te_userid, item.te_username)}
                                        style={{ cursor: "pointer" }}
                                      />
                                    )}
                                  {/* <DeleteSVG
                                    onClick={() =>
                                      openDeleteModal(
                                        item.te_userid,
                                        item.te_username
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  /> */}
                                </div>
                              </td>

                            </tr>
                          ))}
                        </tbody>
                        ) : (
                          <p>You do not have permission to view the user list.</p>
                        )}
                      </table>

                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <SuccessAlert />
        <FailureAlert />
        <InformationAlert />
        <SuccessUpdate />
        <FailureUpdate />
        <SuccessDelete />
      </div>
      <Modal show={isDeleteOpen} onHide={closeDeleteModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the user {selectedUserName}?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeDeleteModal}>
            Cancel
          </Button>
          <Button
            style={{ background: "#703BF7 ", border: "#703BF7 " }}
            onClick={() => DeleteUser(selectedUserId)}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ListUsers;
